import {
  MenuItem,
  SelectProps as MUISelectProps,
  TextField,
} from "@mui/material";
import { ArrowDown } from "@/components";

type SelectProps = MUISelectProps & {
  label: string;
  values: Array<string | number>;
  name: string;
  helperText: string;
  width?: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: any;
  disabled?: boolean;
};

export const Select = ({
  label,
  values,
  name,
  onChange,
  value,
  error,
  helperText,
  disabled,
}: SelectProps) => {
  const fieldId = `send-request-select-${name}`;
  const labelId = `${fieldId}-label`;

  return (
    <TextField
      id={fieldId}
      select
      label={label}
      helperText={helperText}
      name={name}
      placeholder={label}
      value={value}
      error={error}
      onChange={onChange}
      disabled={disabled}
      size="small"
      fullWidth
      slotProps={{
        inputLabel: {
          component: "span",
          id: labelId,
        },
        select: {
          id: fieldId,
          labelId,
          SelectDisplayProps: { id: fieldId },
          inputProps: { "aria-labelledby": labelId },
          MenuProps: {
            PaperProps: {
              style: {
                maxHeight: 220,
                overflowY: "auto",
              },
            },
          },
          IconComponent: (props) => <ArrowDown {...props} />,
        },
      }}
    >
      {values.map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </TextField>
  );
};
